import React from 'react';
import classNames from 'classnames';
import './EditorConfigButton.less';
import { Button } from 'components/buttons'

export interface IEditorConfigButtonProps extends React.HTMLProps<{}> { }

const getClassName = (className?: string) => classNames('dpc-editor-config-button', className);

/**
 * Buttons that appear below editor inputs and provide additional configuration,
 * such as opening a dialog for a ArrayEditor.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function EditorConfigButton({ children, className, onClick, disabled }: IEditorConfigButtonProps) {
  return (
    <Button className={getClassName(className)}
      variant='link'
      onClick={onClick}
      fontSize={"small"}
      fontWeight={"medium"}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
